export default function TapSonic() {
  return (
    <div className='space-y-10'>
      <div className='space-y-2'>
        <p className='text-xs text-gray-500 opacity-50'>HTML5 프로토타입 제작</p>
        <h2 className='text-2xl pb-4 text-gray-900 dark:text-gray-200'>
          <span className='font-title'>탭소닉 HTML5</span>
        </h2>
        <p className='text-sm text-gray-500 opacity-75'>모바일 게임을 브라우저에서</p>
      </div>
      <div className=''>
        <h2 className='subtitle'>
          <span className='font-title'>프롤로그</span>
        </h2>
        <p className='text-sm text-gray-500 opacity-75'>...</p>
      </div>
      <div className=''>
        <h2 className='subtitle'>
          <span className='font-title'>개발 스택</span>
        </h2>
        <p className='text-sm text-gray-500 opacity-75'>...</p>
      </div>
      <div className=''>
        <h2 className='subtitle'>
          <span className='font-title'>기능</span>
        </h2>
        <p className='text-sm text-gray-500 opacity-75'>스크린샷...</p>
      </div>
      <div className=''>
        <h2 className='subtitle'>
          <span className='font-title'>에필로그</span>
        </h2>
        <p className='text-sm text-gray-500 opacity-75'>...</p>
      </div>
    </div>
  )
}
